import React, {Fragment} from 'react';
import {Box, Divider} from '@mui/material';

import {Step1Form} from 'presentation/pages/public/sign-up/components/Forms';
import {Alert} from 'presentation/pages/public/sign-up/components/Alert';
import {ContractNow} from 'presentation/pages/public/components';
import {GoToLogin} from 'presentation/pages/public/sign-up/components/GoToLogin';
import {useMediaQueries} from 'presentation/pages/private';
import {TermsOfUseAndPrivacyPolicy} from 'presentation/pages/public/components/TermsOfUseAndPrivacyPolicy';

export function Step1() {
	const {isTablet} = useMediaQueries();

	return (
		<Fragment>
			<Alert />
			<Step1Form />
			<Divider />
			<GoToLogin />
			<TermsOfUseAndPrivacyPolicy />
			<Box mb={isTablet ? 8 : 0}>
				<ContractNow />
			</Box>
		</Fragment>
	);
}
